import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { CalculatorService } from '../services/calculator.service';
import { TouchSequence } from 'selenium-webdriver';

@Component({
  selector: 'app-quicksearch',
  templateUrl: './quicksearch.component.html',
  styleUrls: ['./quicksearch.component.css']
})
export class QuicksearchComponent implements OnInit {

  userId: string;
  searchResults: any[];

  constructor(private authService: AuthService, private calculatorService: CalculatorService) { }

  ngOnInit() {
    this.authService.getProfile().subscribe(data =>{
      console.log(data);
      this.userId = data.content._id;
      console.log(this.userId);
      this.getUserSearchHistory();
    }, err => {
      alert("Failed to retrieve user details.");
    });    
  }

  getUserSearchHistory(){
    this.calculatorService.getUserSearchHistory(this.userId).subscribe(res =>{
      console.log(res);
      this.searchResults = res;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/quicksearch/quicksearch.component.ts